module.exports = __webpack_public_path__ + "img/megaphone.7022a6c7.svg";